import React from 'react';
import { TemplateFrame } from '../TemplateFrame';
import { AlertCircle, Check } from 'lucide-react';
export function AdVariantsPage() {
  return <div className="max-w-6xl mx-auto py-12 px-8 space-y-16" data-id="element-345">
      {/* Header */}
      <div data-id="element-346">
        <p className="font-mono text-xs text-film-gray mb-3" data-id="element-347">05_AD_VARIANTS</p>
        <h1 className="font-display font-bold text-4xl text-film-black mb-2" data-id="element-348">
          Ad Variants
        </h1>
        <p className="text-film-gray" data-id="element-349">
          Same as winning organic, with extra safe zones for IG ad UI overlays.
        </p>
      </div>

      <div className="bg-film-stored/40 border border-film-red/30 p-5 flex gap-3" data-id="element-350">
        <AlertCircle className="w-5 h-5 text-film-red shrink-0 mt-0.5" data-id="element-351" />
        <div data-id="element-352">
          <p className="font-display font-bold text-sm text-film-black mb-1" data-id="element-353">
            Rule of thumb
          </p>
          <p className="text-sm text-film-gray" data-id="element-354">
            Paid versions need ~100px more bottom safe zone for the IG CTA
            button, and an extra ~80px top zone for the "Sponsored" label.
          </p>
        </div>
      </div>

      {/* Reel Ad */}
      <section data-id="element-355">
        <p className="font-mono text-[10px] uppercase tracking-wider text-film-gray mb-1" data-id="element-356">
          § REEL_AD
        </p>
        <h2 className="font-display font-bold text-2xl text-film-black mb-1" data-id="element-357">
          Reel Ad
        </h2>
        <p className="text-sm text-film-gray mb-6" data-id="element-358">
          Compare organic vs paid. Note the additional bottom CTA zone.
        </p>
        <div className="flex flex-wrap gap-8 items-start" data-id="element-359">
          {/* Organic */}
          <TemplateFrame componentId="CAT_FEATURE / FMT_REEL_COVER · Organic" dimensions="1080×1920 · 9:16" caption="Original feed version." data-id="element-360">
            <div className="relative bg-film-cream w-full" style={{
            aspectRatio: '9/16'
          }} data-id="element-361">
              <div className="absolute top-0 left-0 right-0 border-b border-dashed border-film-red/40 bg-film-red/5" style={{
              height: '14%'
            }} data-id="element-362">
                <span className="absolute bottom-0.5 right-2 font-mono text-[7px] text-film-red/70" data-id="element-363">
                  IG UI
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 border-t border-dashed border-film-red/40 bg-film-red/5" style={{
              height: '20%'
            }} data-id="element-364">
                <span className="absolute top-0.5 right-2 font-mono text-[7px] text-film-red/70" data-id="element-365">
                  IG UI
                </span>
              </div>
              <div className="absolute inset-0 flex flex-col p-5" data-id="element-366">
                <div className="mt-[14%] flex justify-end" data-id="element-367">
                  <span className="font-mono text-[8px] uppercase tracking-wider bg-film-red text-white px-1.5 py-0.5" data-id="element-368">
                    NEW
                  </span>
                </div>
                <div className="flex-1 flex items-center justify-center" data-id="element-369">
                  <div className="bg-film-black rounded-xl w-[60%] aspect-[9/16]" data-id="element-370"></div>
                </div>
                <div className="mb-[20%]" data-id="element-371">
                  <h3 className="font-display font-bold text-film-black text-2xl" data-id="element-372">
                    Track every roll.
                  </h3>
                </div>
              </div>
            </div>
          </TemplateFrame>

          <div className="font-mono text-2xl text-film-gray pt-32" data-id="element-373">→</div>

          {/* Paid */}
          <TemplateFrame componentId="FMT_AD / REEL_COVER · Paid" dimensions="1080×1920 · 9:16" caption="Extra zones for Sponsored label + CTA button." data-id="element-374">
            <div className="relative bg-film-cream w-full" style={{
            aspectRatio: '9/16'
          }} data-id="element-375">
              {/* Sponsored zone (extra top) */}
              <div className="absolute top-0 left-0 right-0 border-b-2 border-dashed border-film-orange bg-film-orange/10 z-10" style={{
              height: '18%'
            }} data-id="element-376">
                <span className="absolute bottom-1 left-2 font-mono text-[7px] text-film-orange uppercase font-bold" data-id="element-377">
                  + AD ZONE
                </span>
                <div className="absolute bottom-1 right-2 bg-white px-1.5 py-0.5 font-mono text-[7px] text-film-black" data-id="element-378">
                  Sponsored
                </div>
              </div>
              {/* CTA zone (extra bottom) */}
              <div className="absolute bottom-0 left-0 right-0 border-t-2 border-dashed border-film-orange bg-film-orange/10 z-10" style={{
              height: '24%'
            }} data-id="element-379">
                <span className="absolute top-1 left-2 font-mono text-[7px] text-film-orange uppercase font-bold" data-id="element-380">
                  + CTA ZONE
                </span>
                <div className="absolute bottom-3 left-3 right-3 bg-film-red text-white text-center py-1.5 font-mono text-[10px] font-bold" data-id="element-381">
                  INSTALL NOW →
                </div>
              </div>
              <div className="absolute inset-0 flex flex-col p-5" data-id="element-382">
                <div className="mt-[18%] flex justify-end" data-id="element-383">
                  <span className="font-mono text-[8px] uppercase tracking-wider bg-film-red text-white px-1.5 py-0.5" data-id="element-384">
                    NEW
                  </span>
                </div>
                <div className="flex-1 flex items-center justify-center" data-id="element-385">
                  <div className="bg-film-black rounded-xl w-[55%] aspect-[9/16]" data-id="element-386"></div>
                </div>
                <div className="mb-[24%]" data-id="element-387">
                  <h3 className="font-display font-bold text-film-black text-xl" data-id="element-388">
                    Track every roll.
                  </h3>
                </div>
              </div>
            </div>
          </TemplateFrame>
        </div>
      </section>

      {/* Single Ad */}
      <section data-id="element-389">
        <p className="font-mono text-[10px] uppercase tracking-wider text-film-gray mb-1" data-id="element-390">
          § SINGLE_AD
        </p>
        <h2 className="font-display font-bold text-2xl text-film-black mb-1" data-id="element-391">
          Single Post Ad
        </h2>
        <p className="text-sm text-film-gray mb-6" data-id="element-392">
          Community single repurposed for paid. Photo credit stays.
        </p>
        <div className="flex flex-wrap gap-8 items-start" data-id="element-393">
          <TemplateFrame componentId="FMT_AD / SINGLE · Community Boost" dimensions="1080×1080 · 1:1" caption="Paid variant of community single." width="320px" data-id="element-394">
            <div className="relative" style={{
            aspectRatio: '1/1'
          }} data-id="element-395">
              <img src="https://images.unsplash.com/photo-1495121553079-4c61bcce1894?w=600&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-396" />
              {/* Sponsored top */}
              <div className="absolute top-0 left-0 right-0 bg-white/95 px-3 py-1.5 flex items-center justify-between border-b border-dashed border-film-orange z-10" data-id="element-397">
                <span className="font-mono text-[9px] text-film-black" data-id="element-398">
                  filmnotes · Sponsored
                </span>
                <span className="font-mono text-[8px] text-film-orange" data-id="element-399">
                  + AD ZONE
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-film-cream p-3 border-t-2 border-film-red" data-id="element-400">
                <p className="font-display font-bold text-xs text-film-black mb-0.5" data-id="element-401">
                  Track rolls like @sarah_analog
                </p>
                <p className="font-mono text-[8px] text-film-gray" data-id="element-402">
                  PORTRA 400 · NIKON FM2
                </p>
              </div>
            </div>
          </TemplateFrame>

          <div className="flex-1 min-w-[280px] space-y-3 pt-2" data-id="element-403">
            <p className="font-mono text-[10px] uppercase tracking-wider text-film-gray" data-id="element-404">
              Annotations
            </p>
            <div className="space-y-2" data-id="element-405">
              {['Top: "Sponsored" + handle replaces normal user header.', 'Bottom: CTA button rendered by IG over the photo — keep no key text in lowest 80px.', 'Maintain creator credit on community boosts (legal requirement).', 'Boost only after written permission for face/scan rights.'].map((line, i) => <div key={i} className="flex gap-2 items-start text-sm" data-id="element-406">
                  <Check className="w-3.5 h-3.5 text-film-red shrink-0 mt-1" data-id="element-407" />
                  <p className="text-film-black" data-id="element-408">{line}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </div>;
}